import { Search, Filter, List, Grid } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { ViewMode } from "./types"

type TalentSearchBarProps = {
  searchQuery: string
  onSearchChange: (query: string) => void
  onFilterClick: () => void
  viewMode: ViewMode
  onViewModeChange: (mode: ViewMode) => void
}

export function TalentSearchBar({
  searchQuery,
  onSearchChange,
  onFilterClick,
  viewMode,
  onViewModeChange
}: TalentSearchBarProps) {
  return (
    <div className="flex items-center gap-4">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
        <Input 
          placeholder="Search by name, email, or skills..." 
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-10"
        />
      </div>
      
      <Button variant="outline" className="flex gap-2" onClick={onFilterClick}>
        <Filter size={16} />
        <span>Filters</span>
      </Button>
      
      <div className="flex border rounded-md overflow-hidden">
        <Button 
          variant={viewMode === "list" ? "default" : "ghost"}
          size="sm"
          onClick={() => onViewModeChange("list")}
          className="rounded-none"
        >
          <List size={16} />
        </Button>
        <Button 
          variant={viewMode === "grid" ? "default" : "ghost"}
          size="sm"
          onClick={() => onViewModeChange("grid")}
          className="rounded-none"
        >
          <Grid size={16} />
        </Button>
      </div>
    </div>
  )
} 